import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Uploads a file to object storage, returns a fully-qualified public URL
export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return `${BACKEND_URL}${data.url}`;
}
